import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class ApiConsumablesService {
  baseURL: string;

  constructor(private authService: AuthService, private http: HttpClient) {
    if (window.location.href.includes('localhost')) {
      this.baseURL = 'http://localhost';
    } else {
      // when is deployed
      this.baseURL = `${environment.url}`;
    }
  }

  getAllConsumables(params: any) {
    /*const filters = `?firstResult=${params.first}&maxResults=${params.max}&sort=${params.sortField}&sort=${params.sort}`;
    const endpoint = `/api/im/consumable/list` + filters;
    return this.http.get(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });*/
    
    const filters = `?firstResult=${params.first}&maxResults=${params.max}&sort=${params.sortField}&sort=${params.sort}`;
    const endpoint = `/api/wm/consumable/list` + filters;
    return this.http.get(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.supplierId, params.workareaId)
    });
  }

  //consumable/{tenantId}/{taskId}/list
  getTaskConsumables(params: any) {
    const filters = `?firstResult=${params.first}&maxResults=${params.max}&sort=${params.sortField}&sort=${params.sort}`;
    const endpoint = `/api/wm/task/${params.taskId}/consumable/list` + filters;
    return this.http.get(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }

  deleteTaskConsumable(params: any) {
    const endpoint = `/api/wm/task/consumable/${params.consumableId}/delete`;
    return this.http.delete(this.baseURL + endpoint, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }

  createTaskConsumable(body: any, params: any) {
    const endpoint = `/api/wm/consumable/add`;
    return this.http.post(this.baseURL + endpoint, body, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }

  updateTaskConsumable(body: any, params: any) {
    const endpoint = `/api/wm/consumable/task/update`;
    return this.http.put(this.baseURL + endpoint, body, {
      headers: this.authService.getHeadersWithTenant(params.tenantId, params.workareaId)
    });
  }
}
